var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCarbonNeutral(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100px",
    height: "100px",
    viewBox: "0 0 100 100",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group 10 Copy 8") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Carbon-Neutral",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Instant-Rate",
    transform: "translate(-391.000000, -395.000000)",
    stroke: "#318A1E",
    strokeWidth: 5
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    transform: "translate(32.000000, 184.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-10-Copy-8",
    transform: "translate(359.000000, 211.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-8-Copy",
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 50,
    cy: 50,
    r: 47.5
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-9",
    transform: "translate(12.416667, 27.000000)",
    fill: "#D3F4CC"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M70.3684211,4.91991282 C68.8612202,20.9991506 62.6901305,32.3110408 56.4071716,37.6573711 C51.3599005,41.9522231 43.1917767,41.5836418 38.0663601,40.0324296 L48.4668589,28.7236851 L34.6494455,37.6737264 C32.0318968,26.8252715 39.9974648,14.3224617 70.3684211,4.91991282 Z",
    id: "Combined-Shape",
    transform: "translate(52.276316, 23.012018) rotate(-13.000000) translate(-52.276316, -23.012018) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.57894737,4.91991282 C21.7513492,2.96646658 51.5570647,8.23315809 55.7549985,51.9693449 C54.8902056,52.4594982 53.9044699,52.8747929 52.8231838,53.2028934 L38.9738641,34.5097566 L46.8655342,54.0590318 C41.3548853,54.1009002 34.9106106,52.2880703 29.3560084,47.73479 C20.2804636,40.2952833 14.6863692,20.0502068 4.57894737,4.91991282 Z",
    id: "Combined-Shape",
    transform: "translate(30.166973, 29.319343) rotate(10.000000) translate(-30.166973, -29.319343) "
  }))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCarbonNeutral);
export default __webpack_public_path__ + "static/media/CarbonNeutral.e9c67193a2756f4b75db30f832c1bfd1.svg";
export { ForwardRef as ReactComponent };